import React, { createContext, useContext, useReducer } from "react";

interface AuthContextType {
  isAuth: boolean;
  login: (res: any) => void;
  logout: (err?: any) => void;
}
const AuthContext = createContext<AuthContextType | undefined>(undefined);
interface AuthProviderProps {
  children: React.ReactNode;
}
enum Type {
  LOGIN = "LOGIN",
  LOGOUT = "LOGOUT",
}
interface ActionType {
  type: Type.LOGIN | Type.LOGOUT;
  payload?: any;
}

const authHandler = (state: boolean, action: ActionType): boolean => {
  switch (action.type) {
    case Type.LOGIN: {
      localStorage.setItem("access_token", action.payload.data.token);
      return true;
    }
    case Type.LOGOUT: {
      localStorage.removeItem("access_token");
      localStorage.clear();

      return false;
    }
    default:
      return state;
  }
};

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [isAuth, dispatch] = useReducer(
    authHandler,
    !!localStorage.getItem("access_token")
  );
  const login = (res: any) => {
    Promise.resolve()
      .then(() => {
        dispatch({ type: Type.LOGIN, payload: res });
      })
      .then(() => {});
  };
  const logout = (err?: any) => {
    Promise.resolve()
      .then(() => {
        dispatch({ type: Type.LOGOUT, payload: err });
      })
      .then(() => {});
  };
  const contextValue: AuthContextType = {
    isAuth,
    login,
    logout,
  };
  return (
    <AuthContext.Provider value={contextValue}>{children}</AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};
